import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { formatDuration, getTopRatedMovies } from "@/lib/movies";

export default function TopRatedSection() {
  const top = getTopRatedMovies(6);
  const champion = top[0];
  const rest = top.slice(1, 6);

  if (!champion) return null;

  return (
    <section className="bg-background-100/60 border-y border-background-200/70">
      <div className="px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <div className="max-w-shell mx-auto">
          <SectionHeading
            eyebrow="TOP RATED"
            title="高分榜单"
            description="按评分排序的年度口碑片单，适合想先从经典入手的观众。"
            action={{ label: "按评分筛选", to: "/category/all" }}
          />

          <div className="grid lg:grid-cols-[minmax(0,1fr)_340px] gap-6 lg:gap-10">
            <div className="rounded-lg border border-background-200/70 bg-background-50/60 overflow-hidden">
              {rest.map((movie, index) => (
                <Link
                  key={movie.id}
                  to={`/detail/${movie.id}`}
                  className="group flex items-center gap-4 px-4 md:px-5 py-3.5 border-b border-background-200/60 last:border-b-0 hover:bg-background-100 transition-colors cursor-pointer"
                >
                  <span className="font-label text-2xl md:text-3xl text-background-400 w-8 shrink-0 text-center group-hover:text-primary-500 transition-colors">
                    {String(index + 2).padStart(2, "0")}
                  </span>
                  <div className="w-12 h-16 md:w-14 md:h-20 rounded overflow-hidden shrink-0 bg-background-200">
                    <img
                      src={movie.poster}
                      alt={`${movie.title} 海报`}
                      title={`${movie.title} - 韩国伦理电影`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-heading text-sm md:text-base text-foreground-950 font-medium truncate group-hover:text-primary-400 transition-colors">
                      {movie.title}
                    </h3>
                    <p className="mt-1 text-xs text-foreground-500 truncate">
                      {movie.year} · {movie.director} · {formatDuration(movie.duration)}
                    </p>
                    <div className="mt-1.5 flex flex-wrap gap-1">
                      {movie.tags.slice(0, 2).map((tag) => (
                        <span
                          key={tag}
                          className="h-5 px-1.5 rounded bg-secondary-100/70 text-secondary-900 text-[10px] flex items-center"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div className="flex items-center gap-1.5 shrink-0">
                    <i className="ri-star-fill text-accent-500 text-sm" aria-hidden="true"></i>
                    <span className="font-label text-lg text-foreground-950">{movie.rating.toFixed(1)}</span>
                  </div>
                </Link>
              ))}
            </div>

            <div className="relative rounded-lg overflow-hidden border border-background-200/70 min-h-[420px]">
              <img
                src={champion.backdrop ?? champion.poster}
                alt={`${champion.title} 剧照`}
                title={`${champion.title} - 韩国伦理电影在线观看`}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/80 to-background-50/20"></div>
              <div className="relative h-full flex flex-col justify-end p-5 md:p-6">
                <span className="self-start h-6 px-2 rounded bg-accent-500 text-background-50 text-[11px] font-medium flex items-center mb-3">
                  年度评分第一
                </span>
                <Link to={`/detail/${champion.id}`} className="group cursor-pointer">
                  <h3 className="font-heading text-2xl md:text-3xl text-foreground-950 font-bold group-hover:text-primary-400 transition-colors">
                    {champion.title}
                  </h3>
                  <p className="mt-1 font-label text-xs tracking-[0.2em] text-primary-400">
                    {champion.originalTitle}
                  </p>
                </Link>
                <div className="mt-3 flex items-center gap-3 text-xs text-foreground-600">
                  <span className="flex items-center gap-1 text-accent-500 font-medium">
                    <i className="ri-star-fill" aria-hidden="true"></i>
                    {champion.rating.toFixed(1)}
                  </span>
                  <span>{champion.year}</span>
                  <span>{formatDuration(champion.duration)}</span>
                </div>
                <p className="mt-3 text-sm text-foreground-700 leading-relaxed line-clamp-3">
                  {champion.synopsis}
                </p>
                <Link
                  to={`/detail/${champion.id}`}
                  className="mt-5 h-10 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-medium flex items-center justify-center gap-2 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-play-fill text-base" aria-hidden="true"></i>
                  查看影片详情
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}